import "./App.css";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Login from "./routes/login";
import Dashboard from "./routes/dashboard";
import Members from "./routes/members";
import { getToken, getUser } from "./utils/helper";
import MemberProfile from "./routes/memberProfile";
import Settings from "./routes/settings";
import History from "./routes/history";
import Rewards from "./routes/rewards";
import Roles from "./routes/roles";
import SetPassword from "./routes/setPassword";
import GlobalContextWrapper from "./contexts/GlobalContextWrapper";
import { ThemeProvider } from "./contexts/ThemeContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import IconSprite from "./components/ui/IconSprite";
import AppLayout from "./layouts/AppLayout";

const ProtectedRoute = ({ children }) => {
  const user = getUser();
  const token = getToken();
  const location = useLocation();

  if (user && token)
    return (
      <SettingsProvider>
        <GlobalContextWrapper>
          <AppLayout>{children}</AppLayout>
        </GlobalContextWrapper>
      </SettingsProvider>
    );
  else return <Navigate to="/login" state={{ from: location }} />;
};

function App() {
  return (
    <ThemeProvider>
      <IconSprite />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/members"
          element={
            <ProtectedRoute>
              <Members />
            </ProtectedRoute>
          }
        />
        <Route
          path="/members/:id"
          element={
            <ProtectedRoute>
              <MemberProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/history"
          element={
            <ProtectedRoute>
              <History />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rewards"
          element={
            <ProtectedRoute>
              <Rewards />
            </ProtectedRoute>
          }
        />
        <Route
          path="/roles"
          element={
            <ProtectedRoute>
              <Roles />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Toaster />
    </ThemeProvider>
  );
}

export default App;
